<template>
<a :href="uri || content" :target="target">
	<template v-if="displayContent">{{content}}</template>
	<i class="fas fa-external-link-alt" v-else></i>
</a>
</template>

<script>

export default {
	name: "JmLink",
	props: {
		uri: String,
		content: String
	},
	computed: {

		target () {
			return /^(https?:|ftps?)\/\//.test(this.uri || this.content) ? "_blank" : null;
		},

		displayContent () {
			return !this.target || this.content.length < 40;
		}
	}
};
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ItemViewWidgets/Link.vue